var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "emailInput",
      staticClass: "email-input",
      class: {
        "is-active":
          _vm.isFilled || (_vm.isFilled && !_vm.$parent.allInputsBlurred)
      }
    },
    [
      _c(
        "label",
        {
          staticClass: "typographies-paragraph-medium-regular",
          class: _vm.labelClass,
          attrs: { for: _vm.inputId }
        },
        [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "email-input__input",
          on: {
            click: _vm.onFocus,
            focusout: _vm.onBlur,
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              return _vm.onBlur($event)
            }
          }
        },
        [
          _vm._t("tags"),
          _vm._v(" "),
          !_vm.shouldHideInput
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input,
                    expression: "input"
                  }
                ],
                ref: _vm.inputId,
                staticClass: "typographies-paragraph-medium-regular",
                attrs: {
                  id: _vm.inputId,
                  placeholder:
                    _vm.isFocused && !_vm.isFilled
                      ? _vm.$t.__(
                          "email.emailPanels.EmailInput.enter_recipient"
                        )
                      : ""
                },
                domProps: { value: _vm.input },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.input = $event.target.value
                    },
                    _vm.onInput
                  ],
                  focus: _vm.onFocus,
                  keydown: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k(
                          $event.keyCode,
                          ",",
                          undefined,
                          $event.key,
                          undefined
                        )
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.onValidateEmail($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.onValidateEmail($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.onValidateEmail($event)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "down", 40, $event.key, [
                          "Down",
                          "ArrowDown"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onNavigation("down")
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "up", 38, $event.key, [
                          "Up",
                          "ArrowUp"
                        ])
                      ) {
                        return null
                      }
                      return _vm.onNavigation("up")
                    }
                  ]
                }
              })
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "actions",
          class: { "all-line": _vm.emailAddresses.length > 0 && _vm.isFocused }
        },
        [_vm._t("actions")],
        2
      ),
      _vm._v(" "),
      _c(
        "EmailInputDropdown",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dataFromAutocomplete.length > 0 && _vm.isFocused,
              expression: "dataFromAutocomplete.length > 0 && isFocused"
            }
          ],
          ref: "inputDropdown" + _vm.hashPanel,
          attrs: {
            id: "inputDropdown" + _vm.hashPanel,
            dropdownClass: "email-input__dropdown",
            parentRef: _vm.inputId,
            minWidth: 0,
            isVisible: _vm.dataFromAutocomplete.length > 0 && _vm.isFocused,
            loading: _vm.isLoading
          }
        },
        [
          _c(
            "div",
            _vm._l(_vm.dataFromAutocomplete, function(item, index) {
              return _c(
                "CompassDropdownOption",
                {
                  key: index,
                  staticClass: "dropdown-email__option",
                  attrs: {
                    label: item.name + " (" + item.email + ")",
                    value: item.id,
                    hovered: _vm.itemHovered === index
                  },
                  on: {
                    pointerdown: function($event) {
                      $event.preventDefault()
                      return _vm.onItemSelected(item.id)
                    },
                    mouseenter: function($event) {
                      return _vm.onItemHovered(index)
                    }
                  }
                },
                [
                  _c("CompassAvatar", {
                    attrs: {
                      initials:
                        "" + item.firstName.charAt(0) + item.lastName.charAt(0),
                      photo: _vm.getPhotoAvatar(item.avatar),
                      colorType: _vm.getAvatarRandomColor(item),
                      size: "extra-small"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown-email__avatar-text" }, [
                    _c(
                      "span",
                      {
                        staticClass: "avatar-name",
                        class: {
                          "email-already-added": _vm.checkIfEmailAlreadyAdded(
                            item.email
                          )
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item.firstName) +
                            " " +
                            _vm._s(item.lastName) +
                            "\n                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass:
                          "avatar-email typographies-paragraph-small-regular"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(item.email) +
                            "\n                    "
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.checkIfEmailAlreadyAdded(item.email)
                    ? _c("CompassIcon", {
                        staticClass: "dropdown-email__check-icon",
                        attrs: { icon: "check", type: "link" }
                      })
                    : _vm._e()
                ],
                1
              )
            }),
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }